module.exports = __webpack_public_path__ + "img/icon-04.e0286bf6.png";